module.exports = __webpack_public_path__ + "static/ru-1-ff7355c9d81c684dbe9a56157e55dc53.png";